import { render, staticRenderFns } from "./PostTitle.vue?vue&type=template&id=2b228726&"
import script from "./PostTitle.vue?vue&type=script&lang=js&"
export * from "./PostTitle.vue?vue&type=script&lang=js&"
import style0 from "./PostTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports